module.exports = __webpack_public_path__ + "static/march-3056b09c263c36084d2155b5cf3010e4.gif";